import { render, staticRenderFns } from "./FoodCourtCart.vue?vue&type=template&id=2a9c1aa6&scoped=true"
import script from "./FoodCourtCart.vue?vue&type=script&lang=js"
export * from "./FoodCourtCart.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtCart.vue?vue&type=style&index=0&id=2a9c1aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c1aa6",
  null
  
)

export default component.exports